(function (M) {
  if (!M) return;
  var d = document, cp = d.querySelector('.cp');
  if (!cp) return;
  M.all('.cp-card').forEach(function (c) {
    M.tag(c.querySelector('.im'), 'zoom');
    M.tag(c.querySelector('.t'), 'up', { d: 0.15 });
  });
  M.tag('.cp-top h1', 'up');
  M.tag(M.all('.cp-grid > div:not(.cp-brand)'), 'fade', { d: 0.1, step: 0.16 });
  var brand = cp.querySelector('.cp-brand');
  if (brand) {
    brand.setAttribute('data-mo-play', '');
    M.tag(M.all(':scope > b, :scope > .s1, :scope > .s2, :scope > svg', brand), 'up', { d: 0.2, step: 0.12 });
  }
  var NUM = ['500', '120', '5,250', '450', '15', '1.2', '1,000', '45'];
  M.all('.cp-ing li').forEach(function (li, i) {
    M.tag(li, 'up', { d: 0.05 + i * 0.09 });
    if (NUM[i] && !li.classList.contains('est')) {
      var s = M.count(li, NUM[i]);
      if (s) s.setAttribute('data-mo-dur', '1.4');
    }
  });
  M.tag(M.all('.cp-row .ph').filter(function (p) { return p.querySelector('img'); }), 'fade');
  M.tag('.cp-lab img', 'up', { step: 0.14 });
  M.all('.cp-row .tx').forEach(function (tx) {
    M.tag(M.all(':scope > h2, :scope > p', tx), 'up', { step: 0.1 });
  });
  var pct = cp.querySelector('.tx .pct');
  if (pct) {
    var V = [30, 60, 75, 85];
    M.all(':scope > p', pct).forEach(function (p, i) {
      if (V[i] == null) return;
      M.tag(p, 'up', { d: 0.1 + i * 0.12 });
      var b = p.querySelector('b');
      if (b) M.count(b, String(V[i]));
      p.insertAdjacentHTML('beforeend', '<span class="cp-bar mo-deco" aria-hidden="true"><i style="--v:' + (V[i] / 100) + '"></i></span>');
    });
  }
  M.tag('.cp-fda p', 'fade', { step: 0.1 });
  M.tag('.cp-more .cp-sl', 'up');
})(window.FJKMotion);
